//# sourceMappingURL=my-default-month.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-default-month.interface.js
// module id = 1011
// module chunks = 3